import { gql } from '@apollo/client';

// Records one community's course delivery audit for one block.
//
// An upsert on (organisation, community, block) — courses are audited once a block, so saving
// the same block twice corrects the existing row rather than adding a second point to the chart.
// Scores are 0–100; omit one to leave it unscored (null), which is distinct from a zero.
export const SET_COURSE_DELIVERY_AUDIT = gql`
mutation SetCourseDeliveryAudit(
  $communityTagId: Int!
  $blockTagId: Int!
  $confidence: Float
  $capacity: Float
  $connection: Float
  $contribution: Float
  $notes: String
) {
  setCourseDeliveryAudit(
    communityTagId: $communityTagId
    blockTagId: $blockTagId
    confidence: $confidence
    capacity: $capacity
    connection: $connection
    contribution: $contribution
    notes: $notes
  ) {
    period
    blockTagId
    confidence
    capacity
    connection
    contribution
    notes
  }
}`;
